export function saveToLocalStorage(state) {
  try {
    const serializedSate = JSON.stringify(state);
    localStorage.setItem('userSettings', serializedSate);
  } catch (err) {
    console.error('Error saving to local storage', err);
  }
}

export function loadFromLocalStorage() {
  try {
    const settingsState = localStorage.getItem('userSettings');
    return settingsState ? JSON.parse(settingsState) : undefined;
  } catch (err) {
    console.error('Failed to load from localStorage', err);
    return undefined;
  }
}
